export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [4,[2]],
		"/(app)/TYPES2025": [5,[2]],
		"/(app)/antihydra": [7,[2]],
		"/(app)/contribute": [8,[2]],
		"/(app)/method": [9,[2]],
		"/(app)/quanta": [10,[2]],
		"/(app)/skelet": [11,[2]],
		"/(app)/story": [12,[2]],
		"/(app)/team": [13,[2]],
		"/(app)/test-machine-code": [14,[2]],
		"/(thumbnail)/thumbnail/[gid]": [16,[3]],
		"/(pascal.michel)/~pascal.michel": [15],
		"/(app)/[gid=machine]": [6,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';